import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowRight, HiOutlineCheckCircle } from 'react-icons/hi2';

const CaseStudiesPage = () => {
  const caseStudies = [
    {
      img: '/images/case-study-reporting.png',
      badge: 'Finance',
      stat: '40%',
      title: 'Faster Reporting for Global Asset Manager',
      desc: 'Deployed AI-powered reporting automation for a $14B alternative asset management firm, reducing manual reporting cycles by 40% and enabling real-time portfolio insights.',
      results: ['40% faster report generation', '95% reduction in manual errors', '$2M annual cost savings'],
    },
    {
      img: '/images/case-study-search.png',
      badge: 'Technology',
      stat: '60%',
      title: 'Search Time Reduction with Vector Search',
      desc: 'Implemented enterprise vector search for a market-focused planning platform, enabling semantic document retrieval and reducing average search time by 60%.',
      results: ['60% faster search results', '3x improvement in relevance', '85% user satisfaction increase'],
    },
    {
      img: '/images/case-study-reconciliation.png',
      badge: 'Banking',
      stat: '99%',
      title: 'Automated Reconciliation for Global Bank',
      desc: 'Built an AI-driven reconciliation engine for a global banking institution, achieving 99% accuracy in automated transaction matching across millions of daily transactions.',
      results: ['99% reconciliation accuracy', '80% reduction in processing time', 'Zero manual intervention needed'],
    },
    {
      img: '/images/ai-solutions-hero.png',
      badge: 'Healthcare',
      stat: '75%',
      title: 'Clinical Document Intelligence',
      desc: 'Developed an intelligent document processing system for a healthcare network, extracting clinical insights from unstructured medical records with 75% faster processing.',
      results: ['75% faster document processing', '90% extraction accuracy', 'HIPAA-compliant deployment'],
    },
    {
      img: '/images/enterprise-architecture.png',
      badge: 'Manufacturing',
      stat: '50%',
      title: 'Predictive Maintenance Platform',
      desc: 'Deployed predictive maintenance AI for a manufacturing conglomerate, reducing unplanned downtime by 50% through real-time sensor data analysis and ML-based predictions.',
      results: ['50% reduction in downtime', '30% lower maintenance costs', 'Real-time anomaly detection'],
    },
    {
      img: '/images/hero-architecture.png',
      badge: 'Retail',
      stat: '35%',
      title: 'Personalization Engine for E-Commerce',
      desc: 'Built a real-time recommendation engine for a luxury e-commerce platform, increasing conversion rates by 35% through AI-powered personalization.',
      results: ['35% higher conversion', '28% increase in AOV', 'Real-time recommendations'],
    },
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-text">
              <div className="section-label">Success Stories</div>
              <h1>Case Studies</h1>
              <p>See how we've helped enterprises operationalize AI and achieve measurable business outcomes.</p>
            </div>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <img
            src="/images/case-studies-hero.png"
            alt="Enterprise AI Success Metrics & ROI Dashboard"
          />
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="case-studies-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))' }}>
            {caseStudies.map((cs, i) => (
              <div className={`case-card fade-in-up-delay${(i % 4) + 1}`} key={i}>
                <img src={cs.img} alt={cs.title} className="case-card-image" />
                <div className="case-card-content">
                  <div className="case-badge">{cs.badge}</div>
                  <h3 style={{ fontSize: 18, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 12 }}>{cs.title}</h3>
                  <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 16 }}>{cs.desc}</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {cs.results.map((r, j) => (
                      <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                        <HiOutlineCheckCircle style={{ color: 'var(--amber)', fontSize: 16, flexShrink: 0 }} />
                        <span style={{ color: 'var(--text-secondary)' }}>{r}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Want similar results for your organization?</h2>
            <p>Let's discuss how our AI solutions can drive measurable impact for your business.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">Book a Discovery Call <HiOutlineArrowRight /></Link>
              <Link to="/solutions" className="btn-secondary">Our Solutions</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CaseStudiesPage;
